import React from 'react'
import { Typography } from '@healingpaper/cell'

import Section from '@/components/atomic/molecules/Section'
import HospitalBadgeList from '@/components/atomic/organisms/HospitalBadgeList'
import { generateTagId } from '@/utils/test-automation'
import { useTranslation } from '@/lang'
import { HospitalViewBadge } from '@/features/hospital/types/hospital.type'
import theme from '@/theme'

// HospitalDetailTemplate에서 import 하거나 상수로 정의된 값들
export const CCTV_BADGE_CODE = 'HB01'

interface HospitalBadgeSectionProps {
  badgeCodes: string[]
  badges: HospitalViewBadge[]
}

export const HospitalBadgeSection: React.FC<HospitalBadgeSectionProps> = ({ badgeCodes = [], badges = [] }) => {
  const { t } = useTranslation()
  if (!badgeCodes.length) return null
  return (
    <div>
      <div style={{ padding: '26px 26px 0' }}>
        <Typography
          type="title3"
          elementType="h2"
          id={generateTagId('hospital', 'page', 'text', 'title', 'doctorList')}
        >
          {t('templates.hospitalDetail.hospitalBadgeTitle')}{' '}
          <span style={{ color: theme.colors.orange }}>{badgeCodes.length.toLocaleString()}</span>
          {t('templates.hospitalDetail.countUnit')}
        </Typography>
      </div>
      <Section>
        {badgeCodes.find((badgeCode) => badgeCode === CCTV_BADGE_CODE) && (
          <div
            aria-label="cctv callout"
            style={{
              marginBottom: '26px',
              padding: '8px 12px',
              fontSize: '14px',
              fontWeight: 400,
              color: '#666666',
              backgroundColor: theme.colors.gray200,
              borderRadius: '4px',
              wordBreak: 'keep-all',
              overflowWrap: 'break-word',
            }}
          >
            {t('templates.hospitalDetail.cctvLegalInfo')}
          </div>
        )}
        <HospitalBadgeList className="grid grid-cols-2 gap-4" badges={badges || []} />
      </Section>
    </div>
  )
}
